class PatientMessageItem {
    public IndividualMessageId: string;
    public FromEmployee: string;
    public SendDate: Date;
    public Subject: string;
    public ToEmployees: string;
    public Body: string;
}

export { PatientMessageItem };
